import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { QUYTRINH } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { QUYTRINH_API } from '../../utils/apiUrl';

export const quyTrinhGetAllAction = createAsyncThunk(
    QUYTRINH.GET_ALL,
    async (_, { rejectWithValue }) => {
        try {
            const data = await Get(QUYTRINH_API.BASE, null, null);
            if (!data) return rejectWithValue('Không lấy được dữ liệu Quy trình');
            return data; 
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const quyTrinhCreateAction = createAsyncThunk(
    QUYTRINH.CREATE,
    async (model, { rejectWithValue }) => {
        try {
            const res = await Post(QUYTRINH_API.CREATE, null, model, false);

            if (res.status === 200 || res.status === 201) {
                const body = await res.json(); 
                return body;
            }

            let errBody = null;
            try {
                errBody = await res.json(); 
            } catch (e) {
                // nếu không parse được thì bỏ qua
            }
            return rejectWithValue(errBody || 'Tạo Quy trình thất bại');
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const quyTrinhUpdateAction = createAsyncThunk(
    QUYTRINH.UPDATE,
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Put(QUYTRINH_API.UPDATE, id, data);

            if (res && typeof res.status === 'number') {
                if (res.status >= 200 && res.status < 300) {
                    return { id, ...data };
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (e) {
                    // nuốt lỗi stream nếu có
                }
                return rejectWithValue(errBody || 'Cập nhật Quy trình thất bại');
            }

            if (!res) {
                return rejectWithValue('Cập nhật Quy trình thất bại');
            }
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const quyTrinhDeleteAction = createAsyncThunk(
    QUYTRINH.DELETE,
    async (id, { rejectWithValue }) => {
        try {
            const res = await DeleteSingle(QUYTRINH_API.DELETE, id, null);
            if (res.status === 200 || res.status === 204) {
                return id;
            }
            let errBody = null;
            try {
                errBody = await res.json();
            } catch (e) {
                // không đọc được body thì dùng message chung
            }
            return rejectWithValue(errBody || 'Xoá Quy trình thất bại');
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const initialState = {
    list: [],
    loading: false,
    error: null,
};

export const quyTrinhSlice = createSlice({
    name: QUYTRINH.NAME_SLICE,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(quyTrinhGetAllAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(quyTrinhGetAllAction.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload || [];
            })
            .addCase(quyTrinhGetAllAction.rejected, (state, action) => {
                state.loading = false;
                state.error =
                    action.payload ||
                    (action.error && action.error.message) ||
                    'Lỗi khi tải danh sách Quy trình';
            })

            .addCase(quyTrinhCreateAction.fulfilled, (state, action) => {
                if (action.payload) {
                    state.list.push(action.payload);
                }
            })
            .addCase(quyTrinhCreateAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    (action.error && action.error.message) ||
                    'Tạo Quy trình thất bại';
            })

            .addCase(quyTrinhUpdateAction.fulfilled, (state, action) => {
                const updated = action.payload;
                if (!updated) return;
                const idx = state.list.findIndex((x) => x.id === updated.id);
                if (idx >= 0) {
                    state.list[idx] = updated;
                }
            })
            .addCase(quyTrinhUpdateAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    (action.error && action.error.message) ||
                    'Cập nhật Quy trình thất bại';
            })

            .addCase(quyTrinhDeleteAction.fulfilled, (state, action) => {
                const id = action.payload;
                state.list = state.list.filter((x) => x.id !== id);
            })
            .addCase(quyTrinhDeleteAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    (action.error && action.error.message) ||
                    'Xoá Quy trình thất bại';
            });
    },
});

export default quyTrinhSlice.reducer;
